<div class="p-card p-4 no-permissions">
  <h2>No Permissions</h2>
  <p>
    You are signed in, but this OpsViewer account does not currently have permissions assigned.
    Please contact <strong>OpsViewer Support</strong> to be added to a company and gain access.
  </p>

  <section class="diagnostics" aria-label="Sign-in details">
    <h3>Sign-in Details</h3>
    <dl>
      <div>
        <dt>Signed in as</dt>
        <dd>{{ accountName() }}</dd>
      </div>
      <div>
        <dt>Email</dt>
        <dd>{{ accountEmail() }}</dd>
      </div>
      <div>
        <dt>Account ID</dt>
        <dd>{{ accountId() }}</dd>
      </div>
      <div>
        <dt>Tenant ID</dt>
        <dd>{{ tenantId() }}</dd>
      </div>
      <div>
        <dt>Current page</dt>
        <dd>{{ currentUrl() }}</dd>
      </div>
      <div>
        <dt>Authentication redirect data in URL</dt>
        <dd>{{ authRedirectFragmentWasPresent() ? 'Was present and has been removed.' : 'Not present.' }}</dd>
      </div>
    </dl>
  </section>

  @if (userLookup$ | async; as lookup) {
    <section class="diagnostics" aria-label="OpsViewer user details">
      <h3>OpsViewer User Record</h3>
      <dl>
        <div>
          <dt>Status</dt>
          <dd>{{ lookup.status }}</dd>
        </div>
        @if (lookup.errorMessage) {
          <div>
            <dt>Lookup error</dt>
            <dd>{{ lookup.errorMessage }}</dd>
          </div>
        }
        @if (lookup.user) {
          <div>
            <dt>Global admin</dt>
            <dd>{{ lookup.user.isGlobalAdmin ? 'Yes' : 'No' }}</dd>
          </div>
          <div>
            <dt>Company roles</dt>
            <dd>{{ lookup.user.companyRoles?.length ?? 0 }}</dd>
          </div>
          <div>
            <dt>All companies</dt>
            <dd>{{ lookup.user.hasAllCompany ? 'Yes' : 'No' }}</dd>
          </div>
        }
      </dl>

      @if ((lookup.user?.companyRoles?.length ?? 0) > 0) {
        <ul class="role-list">
          @for (role of lookup.user?.companyRoles ?? []; track $index) {
            <li>{{ role.role || 'Role not set' }} - {{ role.companyId || 'Company not set' }}</li>
          }
        </ul>
      }
    </section>
  }

  <p>
    Once your access has changed, <a routerLink="/">click here</a> to return to the home page.
  </p>
</div>
